import { render } from "./IndividualTariff.vue?vue&type=template&id=083dd728&scoped=true"
import script from "./IndividualTariff.vue?vue&type=script&lang=js"
export * from "./IndividualTariff.vue?vue&type=script&lang=js"

import "./IndividualTariff.vue?vue&type=style&index=0&id=083dd728&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083dd728"]])

export default __exports__